// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__0Hqwc","mobile":"style_mobile__-P9ch","laptop":"style_laptop__7SCPK","v3":"style_v3__1NQgy"};